import React from 'react';

const Spinner = ({ className, height }: { className?: string; height?: number }) => {
  return (
    <div className={className}>
      <svg
        width={height ?? '33'}
        height={height ?? '33'}
        viewBox="0 0 32 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="v2-animate-spin"
      >
        <path
          d="M30 16.5723C30 18.4108 29.6379 20.2313 28.9343 21.9298C28.2308 23.6284 27.1995 25.1717 25.8995 26.4718C24.5995 27.7718 23.0561 28.803 21.3576 29.5066C19.659 30.2101 17.8385 30.5723 16 30.5723C14.1615 30.5723 12.341 30.2101 10.6424 29.5066C8.94387 28.803 7.40052 27.7718 6.1005 26.4718C4.80048 25.1717 3.76925 23.6284 3.06569 21.9298C2.36212 20.2313 2 18.4108 2 16.5723C2 14.7338 2.36212 12.9133 3.06569 11.2147C3.76926 9.51613 4.80049 7.97279 6.10051 6.67277C7.40053 5.37275 8.94388 4.34151 10.6424 3.63795C12.341 2.93438 14.1615 2.57226 16 2.57227C17.8385 2.57227 19.659 2.93439 21.3576 3.63796C23.0561 4.34152 24.5995 5.37276 25.8995 6.67278C27.1995 7.9728 28.2308 9.51615 28.9343 11.2147C29.6379 12.9133 30 14.7338 30 16.5723L30 16.5723Z"
          stroke="#F2F4F7"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16 2.57227C17.8385 2.57227 19.659 2.93439 21.3576 3.63795C23.0561 4.34152 24.5995 5.37275 25.8995 6.67277C27.1995 7.97279 28.2308 9.51614 28.9343 11.2147C29.6379 12.9133 30 14.7338 30 16.5723"
          stroke="#154734"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default Spinner;
